import { Box, Divider, IconButton, Modal, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';

import { useMobileViewport } from '@frontend/features/common/hooks/useMobileViewport';
import { Form } from './Form';

interface CreateClientModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateClientModal = ({ open, onClose }: CreateClientModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const viewport = useMobileViewport(open && isMobile);

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="create-client-modal-title">
      <Box
        display="flex"
        flexDirection="column"
        gap={theme.spacing(2)}
        sx={{
          bgcolor: 'background.paper',
          boxShadow: 24,
          ...(isMobile ? {
            position: 'fixed', ...viewport, left: 0, transform: 'none', width: '100%', borderRadius: 0,
            overflowY: 'auto', p: 2, pt: 'max(16px, env(safe-area-inset-top))', pb: 'max(16px, env(safe-area-inset-bottom))',
            '& input, & .MuiSelect-select': { fontSize: 16 },
            '& button': { minHeight: 44 },
            '& form > div:first-of-type': { maxHeight: 'none', overflow: 'visible', '& > div': { gridColumn: '1 / -1' } },
          } : {
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            width: 400, p: theme.spacing(3), borderRadius: theme.spacing(2),
          }),
        }}
      >
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <PersonIcon color="disabled" />
            <Typography id="create-client-modal-title" variant="h6" component="h2">
              {t('clients.create.title')}
            </Typography>
          </Box>
          <IconButton onClick={onClose} aria-label={t('common.close')}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form onClose={onClose} />
      </Box>
    </Modal>
  );
};
